import { useState, useEffect } from "react";

const useForm = (
  callback: any,
  validate: any,
  defaultValues?: any,
  extraInfo?: any
) => {
  const [values, setValues] = useState<any>({ ...defaultValues });
  const [errors, setErrors] = useState<any>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const callCallback = async (errors: any) => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback(values);
    }
  };

  useEffect(() => {
    if (
      defaultValues &&
      JSON.stringify(defaultValues) !== JSON.stringify(values)
    ) {
      setValues(defaultValues);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    callCallback(errors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (JSON.stringify(defaultValues) !== JSON.stringify(values)) {
      if (Object.keys(values).length) {
        setErrors(validate(values, defaultValues, extraInfo));
        setIsSubmitting(false);
      }
    } else {
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const handleSubmit = (event: any) => {
    if (event) event.preventDefault();

    setErrors(validate(values, defaultValues, extraInfo));
    setIsSubmitting(true);
  };

  const handleChange = (event: any) => {
    event.persist && event.persist();
    setValues((values: any) => ({
      ...values,
      [event.target.name]:
        event.target.type !== "checkbox"
          ? event.target.value
          : event.target.checked,
    }));
  };

  const reset = () => {
    setValues({ ...defaultValues });
    setErrors({});
    setIsSubmitting(false);
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    reset,
  };
};

export default useForm;
